var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.037 1.68a.58.58 0 0 0-.562.562v10.125c0 .317.246.563.562.563h1.688a.58.58 0 0 0 .562-.563V2.242c0-.281-.281-.562-.562-.562zM.35 2.242c0-.914.738-1.687 1.687-1.687h1.688c.914 0 1.687.773 1.687 1.687v10.125c0 .95-.773 1.688-1.687 1.688H2.037c-.95 0-1.687-.739-1.687-1.688zm7.875-.562a.58.58 0 0 0-.563.562v10.125c0 .317.246.563.563.563h1.687a.58.58 0 0 0 .563-.563V2.242c0-.281-.282-.562-.563-.562zm-1.688.562c0-.914.738-1.687 1.688-1.687h1.687c.914 0 1.688.773 1.688 1.687v10.125c0 .95-.774 1.688-1.688 1.688H8.225c-.95 0-1.688-.739-1.688-1.688z"
  })));
};
export default SvgPause;